<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>ویرایش {{TypeTitle}}</h2>
                <!--<h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>{{title}}</h2>-->
                <!--<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>-->
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>



            <div class="card card-style">
                <div class="content">
                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check-square color-magenta2-light"></i>
                        <span class="color-highlight input-style-1-active">عنوان</span>
                        <input class="form-control" type="text" v-model="NoticeMassageUser.title">
                    </div>

                    <div class="mb-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" disabled :checked="!NoticeMassageUser.type" name="inlineRadioOptions" id="inlineRadio1" value="option1">
                            <label class="form-check-label mx-1" for="inlineRadio1">اعلام</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" disabled :checked="NoticeMassageUser.type" name="inlineRadioOptions" id="inlineRadio2" value="option2">
                            <label class="form-check-label mx-1" for="inlineRadio2">رویداد</label>
                        </div>
                    </div>
                    <div v-if="NoticeMassageUser.type">
                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-calendar-times color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : NoticeMassageUser.createDate!==null}">تاریخ شروع روز شمار</span>
                            <input type="text" v-model="NoticeMassageUser.createDate" id="createDateDT" class="form-control ltr d-inline-block" />
                        </div>
                        <date-picker type="date" v-model="NoticeMassageUser.createDate" format="jYYYY/jMM/jDD" element="createDateDT" />
                    </div>
                    <div v-if="NoticeMassageUser.type">
                        <div class="mb-4">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center">
                                    <i class="fa fa-clock pl-2 color-magenta2-light"></i>
                                    <label class="mb-0 font-12 font-weight-bold">زمان شروع روز شمار</label>
                                </div>
                                <div class="d-flex flex-column">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <label class="mb-0 font-12 font-weight-bold w-50 text-center">دقیقه</label>
                                        <span class="font-13 font-weight-bold px-3"></span>
                                        <label class="mb-0 font-12 font-weight-bold w-50 text-center">ساعت</label>
                                    </div>
                                    <div class="ltr">
                                        <input placeholder="00" class="form-control ltr d-inline-block text-center" @input="() => { if(NoticeMassageUser.createTimeHour > 23 || NoticeMassageUser.createTimeHour < 0) { NoticeMassageUser.createTimeHour = ''}}" style="max-width:60px" type="tel" maxlength="2" max="23" v-model="NoticeMassageUser.createTimeHour">
                                        <span class="font-13 font-weight-bold px-2">:</span>
                                        <input placeholder="00" @input="() => { if(NoticeMassageUser.createTimeMinute > 59 || NoticeMassageUser.createTimeMinute < 0) { NoticeMassageUser.createTimeMinute = ''}}" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="NoticeMassageUser.createTimeMinute">
                                        <!--<input placeholder="00" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="taskModel.suggestPersonTimeMinute" @change="saveHeader" @input="v$.taskModel.suggestPersonTimeMinute.$touch()" :class="{invalid:v$.taskModel.suggestPersonTimeMinute.$error}">-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-calendar-times color-magenta2-light"></i>
                            <span v-if="NoticeMassageUser.type" class="color-highlight input-style-1-active">تاریخ رویداد</span>
                            <span v-else class="color-highlight input-style-1-active">تاریخ اعلان</span>
                            <input type="text" v-model="NoticeMassageUser.viewDate" id="endDT" class="form-control ltr d-inline-block" />
                        </div>
                        <date-picker type="date" v-model="NoticeMassageUser.viewDate" format="jYYYY/jMM/jDD" element="endDT" />
                    </div>
                    <div class="mb-4">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-clock pl-2 color-magenta2-light"></i>
                                <label v-if="NoticeMassageUser.type" class="mb-0 font-12 font-weight-bold">زمان رویداد</label>
                                <label v-else class="mb-0 font-12 font-weight-bold" id="txtViewTime">زمان اعلان</label>
                            </div>
                            <div class="d-flex flex-column">
                                <div class="d-flex justify-content-between align-items-center">
                                    <label class="mb-0 font-12 font-weight-bold w-50 text-center">دقیقه</label>
                                    <span class="font-13 font-weight-bold px-3"></span>
                                    <label class="mb-0 font-12 font-weight-bold w-50 text-center">ساعت</label>
                                </div>
                                <div class="ltr">
                                    <input placeholder="00" class="form-control ltr d-inline-block text-center" @input="() => { if(NoticeMassageUser.viewTimeHour > 23 || NoticeMassageUser.viewTimeHour < 0) { NoticeMassageUser.viewTimeHour = ''}}" style="max-width:60px" type="tel" maxlength="2" max="23" v-model="NoticeMassageUser.viewTimeHour">
                                    <span class="font-13 font-weight-bold px-2">:</span>
                                    <input placeholder="00" @input="() => { if(NoticeMassageUser.viewTimeMinute > 59 || NoticeMassageUser.viewTimeMinute < 0) { NoticeMassageUser.viewTimeMinute = ''}}" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="NoticeMassageUser.viewTimeMinute">
                                    <!--<input placeholder="00" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="taskModel.suggestPersonTimeMinute" @change="saveHeader" @input="v$.taskModel.suggestPersonTimeMinute.$touch()" :class="{invalid:v$.taskModel.suggestPersonTimeMinute.$error}">-->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--<div class="input-style input-style-2 has-icon input-required">
        <i class="input-icon fa fa-check-square color-magenta2-light"></i>
        <span class="color-highlight" :class="{'input-style-1-active' : NoticeMassageUser.mobileUrl!==null}">آدرس موبایل</span>
        <input class="form-control ltr text-left" type="text" v-model="NoticeMassageUser.mobileUrl">
    </div>-->
                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check-square color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : NoticeMassageUser.webUrl!==null}">آدرس وب</span>
                        <input class="form-control ltr text-left" type="text" v-model="NoticeMassageUser.webUrl">
                    </div>
                    <div class="input-style input-style-2 has-icon input-required mb-0">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight ltr input-style-1-active">توضیحات</span>
                        <textarea v-model="NoticeMassageUser.description" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px"></textarea>
                    </div>
                    <button class="btn btn-link speechToTextBtn mb-3 mt-3" @pointerdown="startR"
                            @pointerup="stopR">
                        <span :class="btnRecord">
                            <span class="speechToTextBtn-text" v-if="showType">شروع به صحبت کنید...</span>
                        </span>
                        <img class="ml-3" v-if="showType" src="/assets/images/wave.gif" width="38" height="38" />
                    </button>


                    <div class="mb-3">
                        <p class="p-2 text-justify mb-0 pt-0" v-if="isMinVersion">
                            در این لیست فقط
                            <b class="text-danger">کابران دارای اشتراک</b>
                            قابل مشاهده هستند. برای دسترسی به
                            <b>لیست تمام کاربران</b>
                            به قسمت
                            <b class="text-danger">خرید اشتراک</b>
                            مراجعه نمایید.
                        </p>
                        <div class="scrollableBox400">
                            <div class="py-2 borderedListBox" v-for="user in LocalUserListList" :key="user.userId">
                                <div class="d-flex align-items-center justify-content-start">
                                    <input :checked="user.selected" :disabled="user.expired" class="big-checkbox UserSelected" type="checkbox" :value="user.userId" :id="user.userId" :key="user.userId" />
                                    <div class="w-100 pr-3">
                                        <div><i class="fa fa-user color-magenta2-light ml-3"></i> <b>{{user.userTitle}}</b></div>
                                        <div v-if="isMinVersion==false"><i class="fa fa-hashtag color-magenta2-light ml-3"></i>کد واحد سازمانی: <b>{{user.orgJobCode}}</b></div>
                                        <div v-if="isMinVersion==false"><i class="fa fa-address-card color-magenta2-light ml-3"></i>عنوان واحد سازمانی: <b>{{user.orgJobTitle}}</b></div>
                                        <div><i class="fa fa-hashtag color-magenta2-light ml-3"></i>کد پست سازمانی: <b>{{user.orgJobCode}}</b></div>
                                        <div><i class="fa fa-address-card color-magenta2-light ml-3"></i>عنوان پست سازمانی: <b>{{user.orgJobTitle}}</b></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="Loading" class="d-flex justify-content-center w-100 py-5">
                            <div class="spinner-border color-magenta2-dark" role="status"></div>
                        </div>
                    </div>
                    <button v-if="NoticeMassageUser.editable" :disabled="pageLoading" class="btn btn-xxs btn-full bg-green1-dark rounded-sm font-900 w-100 mb-3 btn_checkSmsm" @click.prevent="UpdateNoticeMassageUser">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>
            <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
                <div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
                    <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import useVuelidate from '@vuelidate/core'
    import {
        required, between
    } from "@vuelidate/validators";
    import { maska } from 'maska';
    import DatePicker from 'vue3-persian-datetime-picker';
    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition
    import VueSimpleAlert from 'vue3-simple-alert';
    export default {
        components: {
            DatePicker
        },
        data() {
            return {
                title: "",
                TypeTitle: "",
                pageLoading: true,

                showType: false,
                sr: null,
                btnRecord: "btn btn-danger speechToTextBtn-i",

                NoticeMassageUser: {
                    noticeMessageId: 0,
                    noticeMessageUsersJson: null,
                    noticeMessageUsers: [],
                    viewDate: null,
                    viewTime: null,
                    createDate: null,
                    createTime: null,
                    mod: false,
                    createTimeHour: null,
                    createTimeMinute: null,
                    viewTimeHour: null,
                    viewTimeMinute: null,
                    title: null,
                    webUrl: null,
                    mobileUrl: null,
                    description: null,
                    editable: false,
                    type: false,
                }
            }
        },
        methods: {
            startR() {
                try {
                    this.sr.start();
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                } catch (error) {
                    this.showType = true;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }
            },
            stopR() {
                try {
                    this.sr.stop();
                    this.showType = false;
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                } catch (error) {
                    this.showType = false;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }
            },

            PadLeft(text, char, length) {
                return text.toString().padStart(length, char);
            },
            onChangeType(type) {
                this.NoticeMassageUser.type = type;
                if (type) {
                    this.TypeTitle = "رویداد";
                } else {
                    this.TypeTitle = "اعلان";
                }
            },
            UpdateNoticeMassageUser() {
                if (this.NoticeMassageUser.title == null || this.NoticeMassageUser.title == "") {
                    this.showErrorMessage("عنوان را وارد کنید");
                    return;
                }
                if (this.NoticeMassageUser.viewDate == null || this.NoticeMassageUser.viewDate == "") {
                    this.showErrorMessage("تاریخ " + this.TypeTitle + " را وارد کنید");
                    return;
                }

                if ((this.NoticeMassageUser.viewTimeHour == null || this.NoticeMassageUser.viewTimeHour == "") && (this.NoticeMassageUser.viewTimeMinute == null || this.NoticeMassageUser.viewTimeMinute == "")) {
                    this.showErrorMessage("زمان " + this.TypeTitle + " معتبر نیست");
                    return;
                }
                if (this.NoticeMassageUser.type) {
                    if (this.NoticeMassageUser.createDate == null || this.NoticeMassageUser.createDate == "") {
                        this.showErrorMessage("تاریخ شروع روز شمار معتبر نیست");
                        return;
                    }

                    if ((this.NoticeMassageUser.createTimeHour == null || this.NoticeMassageUser.createTimeHour == "") && (this.NoticeMassageUser.createTimeMinute == null || this.NoticeMassageUser.createTimeMinute == "")) {
                        this.showErrorMessage("زمان شروع روز شمار معتبر نیست");
                        return;
                    }

                    if ((this.NoticeMassageUser.createTimeHour == null || this.NoticeMassageUser.createTimeHour == ""))
                        this.NoticeMassageUser.createTimeHour = "00";

                    if ((this.NoticeMassageUser.createTimeMinute == null || this.NoticeMassageUser.createTimeMinute == ""))
                        this.NoticeMassageUser.createTimeMinute = "00";
                    this.NoticeMassageUser.CreateTime = this.NoticeMassageUser.createTimeHour + ":" + this.NoticeMassageUser.createTimeMinute;

                } else {
                    this.NoticeMassageUser.createDate = null;
                    this.NoticeMassageUser.CreateTime = null;
                    this.NoticeMassageUser.createTimeHour = null;
                    this.NoticeMassageUser.createTimeMinute = null;
                }
                if ((this.NoticeMassageUser.ViewTimeHour == null || this.NoticeMassageUser.ViewTimeHour == ""))
                    this.NoticeMassageUser.ViewTimeHour = "00";

                if ((this.NoticeMassageUser.ViewTimeMinute == null || this.NoticeMassageUser.ViewTimeMinute == ""))
                    this.NoticeMassageUser.ViewTimeMinute = "00";
                this.NoticeMassageUser.viewTime = this.PadLeft(this.NoticeMassageUser.viewTimeHour, "0", 2) + ":" + this.PadLeft(this.NoticeMassageUser.viewTimeMinute, "0", 2);
                let checkBox = document.getElementsByClassName("UserSelected");
                let userIds = [];
                let users = [];
                if (checkBox.length > 0) {
                    for (var i = 0; i < checkBox.length; i++) {
                        if (checkBox[i].checked) {
                            userIds.push(checkBox[i].value);
                        }
                        let user = {
                            Selected: userIds.includes(checkBox[i].value),
                            UserId: checkBox[i].value,
                        };
                        users.push(user);
                    }
                }
                if (userIds.length == null || userIds.length <= 0) {
                    this.showErrorMessage("هیچ کاربری انتخاب نشده است");
                    return;
                }
                this.NoticeMassageUser.noticeMessageUsersJson = userIds.join(",");
                this.NoticeMassageUser.noticeMessageUsers = users;
                this.pageLoading = true;
                this.$http.post("NoticeMassageUser/Update", this.NoticeMassageUser)
                    .then(data => {
                        this.pageLoading = false;
                        var res = data.data;
                        if (res.isSuccess) {
                            this.showSuccessMessage(res.message);
                            this.goBack();
                        } else {
                            this.showErrorMessage(res.message);

                            this.GetNoticeMassageUserItemData();
                        }
                    });

            },
            GetNoticeMassageUserList() {
                this.pageLoading = true;
                this.$http
                    .get("NoticeMassageUser/NotificationMessageUser?id=" + this.NoticeMassageUser.noticeMessageId)
                    .then((data) => {
                        var res = data.data;
                        this.NoticeMassageUser.noticeMessageUsers = res;
                        this.pageLoading = false;
                    });

            },
            GetNoticeMassageUserItemData() {
                this.pageLoading = true;
                this.$http
                    .get("NoticeMassageUser/GetById?id=" + this.NoticeMassageUser.noticeMessageId)
                    .then((data) => {
                        var res = data.data;
                        this.NoticeMassageUser = res;
                        this.onChangeType(this.NoticeMassageUser.type)
                        this.pageLoading = false;
                        this.GetNoticeMassageUserList();

                    });

            },
        },
        computed: {

            LocalUserListList() {
                return this.NoticeMassageUser.noticeMessageUsers;
            },
        },
        created() {
            this.$store.dispatch("CheckUserSMS");
            this.NoticeMassageUser.noticeMessageId = this.$route.params.NoticeMessageId;

            this.GetNoticeMassageUserItemData();

        },
        mounted() {
            this.pageLoading = false;
            try {
                this.sr = new Recognition()
                this.sr.continuous = true
                this.sr.interimResults = true
                this.sr.lang = 'fa-IR';
                var rest = "";
                this.sr.onstart = () => {
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                }
                this.sr.onresult = (evt) => {
                    rest = evt.results[evt.results.length - 1][0].transcript;
                }
                this.sr.onend = () => {
                    rest = rest.replaceAll("علامت سوال", "؟");
                    rest = rest.replaceAll("علامت تعجب", "!");
                    rest = rest.replaceAll("علامت بزرگتر", ">");
                    rest = rest.replaceAll("علامت کوچکتر", "<");
                    rest = rest.replaceAll("پرانتز باز", "(");
                    rest = rest.replaceAll("پرانتز بسته", ")");
                    rest = rest.replaceAll("شارپ", "#");
                    rest = rest.replaceAll("ستاره", "*");
                    rest = rest.replaceAll("دو نقطه", ": ");
                    rest = rest.replaceAll("نقطه ویرگول", "; ");
                    rest = rest.replaceAll("نقطه", ". ");
                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("پاراگراف جدید", "\n");
                    rest = rest.replaceAll("پاراگراف بعد", "\n");
                    rest = rest.replaceAll("پاراگراف بعدی", "\n");
                    rest = rest.replaceAll("پاراگراف", "\n");
                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("خط بعدی", "\n");
                    rest = rest.replaceAll("خط بعد", "\n");
                    rest = rest.replaceAll("خط جدید", "\n");

                    if (this.NoticeMassageUser.description == null || this.NoticeMassageUser.description == "null")
                        this.NoticeMassageUser.description = "";
                    if (rest != null && rest != '')
                        this.NoticeMassageUser.description = this.NoticeMassageUser.description + " " + rest
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                    rest = "";
                    this.showType = false;
                }
            } catch (error) {
                console.error(error);
                // Expected output: ReferenceError: nonExistentFunction is not defined
                // (Note: the exact output may be browser-dependent)
            }

        },
        validations: {
            NoticeMassageUser: {
                ViewDate: {
                    required,
                },
                ViewTime: {
                    required
                },
                Title: {
                    required
                }
            }
        },
        directives: { maska },
    }
</script>